import * as sharedApi from '../reportsApi';
import * as types from './types';
import { apiAction } from '../../../shared/store/apiAction';

export const fecthEntityAnalyticalReviewReport = apiAction({
  types: types.fecthEntityAnalyticalReviewReportTypes,
  apiAction: sharedApi.fecthEntityAnalyticalReviewReport,
});

export const fetchConsolStateConsolidatedReport = apiAction({
  types: types.fetchConsolidatedStateConsolidatedReportTypes,
  apiAction: sharedApi.fetchConsolStateConsolidatedReport,
});

export const fetchNexusConsolAnalysisReport = apiAction({
  types: types.fetchNexusConsolAnalysisReportTypes,
  apiAction: sharedApi.fetchNexusConsolAnalysisReport,
});

export const fetchInterCompanyDividendAnalysisReport = apiAction({
  types: types.fetchInterCompanyDividendAnalysisReportTypes,
  apiAction: sharedApi.fetchInterCompanyDividendAnalysisReport,
});

export const fetchConsolSTISummaryPushbackStatesReport = apiAction({
  types: types.fetchConsolSTISummaryPushbackStateReportTypes,
  apiAction: sharedApi.fetchConsolSTISummaryPushbackStatesReport,
});

export const fetchConsolSTIReconciliationReport = apiAction({
  types: types.fetchConsolSTIReconciliationReportTypes,
  apiAction: sharedApi.fetchConsolSTIReconciliationReport,
});
